import { CartEntry } from "../../../library-js/php/cart/CartEntry";
import { Rokojori } from "../Rokojori";
import { ProductsTable } from "../store/ProductsTable";
import { ProductInfo } from "../store/ProductInfo";
import { CartPrice } from "../../templates/store/CartPrice";
import { ElementType } from "../../../library-js/dom-tools/ElementType";
import { ElementAttribute } from "../../../library-js/dom-tools/ElementAttribute";
import { RokojoriCart } from "./RokojoriCart";
import { OnClick } from "../../../library-js/dom-tools/EventListeners";
import { AddToCartLink } from "./AddToCartLink";
import { TimePin } from "../../../library-js/animation/TimePin";
import { ConsumerPrice } from "../../../library/ts/vanilla/ecommerce/ConsumerPrice";
import { CartList } from "../../templates/cart/CartList";
import { RootPathResolver } from "../../../library-js/dom-tools/RootPathResolver";


export class CartEntryHandler
{

  handle( item:Element, entry:CartEntry, wishlist:boolean )    
  {
    this.processEntry( item, entry, wishlist );
  }
 
  async processEntry( item:Element, entry:CartEntry, wishlist:boolean )
  { 
    let assetInfo = await Rokojori.$.assetManagerServer.getInfo( entry.id );
    
    console.log( "processEntry assetInfo:", assetInfo );

    CartList.label.setText( item, Rokojori.locale( assetInfo.title ) );
    CartList.details.setText( item, Rokojori.locale( assetInfo.details || { en:"---"} ) );

    let cp = ConsumerPrice.fromGross( assetInfo.purchaseOption.price.gross );

    CartList.price.setText( item, ProductInfo.getPrice( assetInfo.purchaseOption ) );
    CartList.tax.setText( item, ConsumerPrice.asLabel( cp.tax ) );

   
    let image = CartList.image.query( item ) as HTMLElement;

    let imagePath = "::/_graphics/assets/asset-no-image.jpg";

    if ( assetInfo.previewImagePath )
    {
      imagePath = Rokojori.locale( assetInfo.previewImagePath );
    }

    if ( RootPathResolver.isRootPath( imagePath ) )
    {
      imagePath = Rokojori.$.pathConverter.rootToRelative( imagePath );
    }

    let hasLink = false;

    if ( hasLink )
    {
      let link = Rokojori.$.pathConverter.rootToRelative( "asset-info/#" + assetInfo.id );
      ElementAttribute.href.to( ElementType.anchor.getParent( image ), link );
    }    

    let addButton = CartList.add.query( item );

    OnClick.add( addButton as HTMLElement, 
      async ()=>
      {      
        Rokojori.$.showLoaderScreen( AddToCartLink.addingText );

        let pin = TimePin.create();

        let result = await Rokojori.$.assetManagerServer.assetsCart.add( assetInfo.id, wishlist );

        await pin.forMS( 500 ); 

        pin.now();

        Rokojori.$.hideLoaderScreen();
        
        await pin.forMS( 200 ); 
      } 
    )

    let removeButton = CartList.remove.query( item );
    OnClick.add( removeButton as HTMLElement, 
      async ()=>
      {      
        Rokojori.$.showLoaderScreen( AddToCartLink.removingText );

        let pin = TimePin.create();

        let result = await Rokojori.$.assetManagerServer.assetsCart.remove( assetInfo.id, wishlist );

        await pin.forMS( 500 ); 

        pin.now();

        Rokojori.$.hideLoaderScreen();
        
      } 
    )

    image.style.backgroundImage = `url("${imagePath}")`;
    console.log( image.style.backgroundImage );

    
  }   


}